import { createFileRoute } from '@tanstack/react-router';
import ActivityDetail from '../../components/webdesigned/ActivityDetail';
import WebDesignedPortal from '../../components/portals/WebDesignedPortal';

export const Route = createFileRoute('/webdesigned/activities_/$id')({
  component: () => (
    <WebDesignedPortal>
      <ActivityDetail />
    </WebDesignedPortal>
  ),
});
